export default "__VITE_ASSET__DQm$1NKm__"